import { Order, PaginatedResult } from "../models";
import { ServiceResponse, FetchService, PaginationParams } from "../shared";
import ServicePaths from "./ServicePaths";

export default class OrderService {
    public static GetOrders(
        pageIndex: number,
        createdDateFrom?: Date,
        createdDateTo?: Date,
        menuId?: number,
        menuTypeCode?: string
    ): Promise<ServiceResponse<PaginatedResult<Order>>> {
        let extra = "";
        if (menuId) extra += `menuId=${menuId}`;
        if (menuTypeCode) extra += `menuTypeCode=${menuTypeCode}`;

        const params = new PaginationParams();
        params.pageIndex = pageIndex;
        params.createdDateFrom = createdDateFrom;
        params.createdDateTo = createdDateTo;
        params.extraParams = extra;

        return FetchService.get<PaginatedResult<Order>>({
            url: ServicePaths.ORDERS,
            paginationParams: params,
        });
    }

    public static CancelOrder(id: number): Promise<ServiceResponse<number>> {
        return FetchService.put({
            url: ServicePaths.CANCEL_ORDER(id),
        });
    }
}
